import styled from '@emotion/styled'
import { themeColor } from 'utils/styles'

import EvaluationBadge from 'components/feature/EvaluationBadge'
import CarryTo from 'components/feature/CarryTo'

export const StyledOutputType = styled.div((props) => {
  const {
    theme: { featureOutputTypeBackground, featureOutputTypeBackgroundSelected },
    isSelected,
  } = props

  return `
    position: relative;
    padding: 6px 10px;
    margin-bottom: 5px;
    width: 100%;
    background: ${
      isSelected
        ? featureOutputTypeBackgroundSelected
        : featureOutputTypeBackground
    };
    min-height: 30px;
  `
})

export const StyledEvaluationBadge = styled(EvaluationBadge)`
  z-index: 2;
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  margin: auto;
  transform: translateX(-50%);
  padding: 0; // ie11
`

export const StyledCarryTo = styled(CarryTo)`
  position: absolute;
  left: -34px;
  top: 0;
  bottom: 0;
  margin: auto;
  height: 20px;
  width: 20px;

  &:after {
    content: '';
    width: 14px;
    height: 2px;
    background: ${themeColor('featureConnectorLines')};
    position: absolute;
    top: 0;
    bottom: 0;
    margin: auto;
  }
`
